import qs from 'qs';
import { network } from 'services/network';

export const getPoapSecondaryViews = (params) => {
    const { customerId } = params;
    const queryString = qs.stringify({ customerId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getPoapSecondaryViews${queryString}`;

    return network.get(url).then((response) => response.data);
};
